import styled, { css } from 'styled-components'

export const PageContainer = styled.div`
  width: 100%;
  margin: 0 auto;
  max-width: 100vw;
  min-height: 100vh;
  margin-top: 90px;
  flex-direction: column;
  gap: 20px;
`

export const Section = styled.div`
  background: white;
  padding: 24px;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  margin-bottom: 24px;
`

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
  margin-bottom: 24px;
`

export const Card = styled.div`
  background: white;
  padding: 24px;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.09);
  transition: 0.25s ease;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 3px 12px rgba(0, 0, 0, 0.12);
  }
`

export const StatsCardWrap = styled.div`
  padding: 24px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  display: flex;
  justify-content: space-between;
`
export const StatsTitle = styled.p`
  color: #666;
  font-size: 14px;
`
export const StatsValue = styled.p`
  font-size: 32px;
  font-weight: bold;
  color: #222;
`

const colors = {
  interview: { bg: '#e7f0ff', color: '#085cd0' },
  pending: { bg: '#fff3cd', color: '#b88a00' },
  rejected: { bg: '#fde2e2', color: '#b71c1c' }
}

export const StatusBadge = styled.span`
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;
  background: ${props => colors[props.status].bg || '#eee'};
  color: ${props => colors[props.status].color || '#555'};
`

export const Header = styled.div`
  padding: 24px;
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;

  h1 {
    font-size: 32px;
    margin: 0;
    font-weight: 700;
    color: ${props => props.theme.primary};
    text-transform: uppercase;
    text-align: center;
  }

  p {
    opacity: 0.9;
    font-size: 16px;
    color: ${props => props.theme.text};
    text-align: center;
  }

  @media (max-width: 768px) {
    padding: 16px 12px;
    margin-bottom: 16px;

    h1 {
      font-size: 22px;
    }
    p {
      font-size: 13px;
    }
  }
`

export const Input = styled.input`
  width: 100%;
  padding: 14px 14px 14px 44px;
  font-size: 15px;
  border-radius: 12px;
  border: 1px solid ${props => (props.error ? '#e63946' : '#e0e0e0')};
  transition: 0.2s;

  &:focus {
    border-color: #667eea;
  }
`

export const Select = styled.select`
  width: 100%;
  padding: 14px 14px 14px 44px;
  font-size: 15px;
  border-radius: 12px;
  background: white;
  cursor: pointer;
  border: 1px solid ${props => (props.error ? '#e63946' : '#e0e0e0')};
  transition: 0.2s;

  &:focus {
    border-color: #667eea;
  }
`

export const Container = styled.div`
  width: 30%;
  max-width: 900px;
  background: #ffffff;
  padding: 16px 24px;
  transition: all 0.35s ease;
  overflow: hidden;

  .search-input {
    border-radius: 40px;
  }
`

export const SearchFields = styled.div`
  display: flex;
  align-items: center;
  gap: 18px;
  width: 70%;
  border: 1px solid #d4d4d4;
  border-radius: 30px;
  padding: 0px 10px;

  @media (max-width: 768px) {
    width: 100%;
    flex-direction: column;
    height: auto !important;
    border-radius: 16px;
    padding: 14px;
    gap: 10px;
    margin-top: 20px !important;
    background: #ffffff;
  }

  input {
    flex: 1;
    border: none;
    outline: none;
    font-size: 14px;
    color: #535353;
    background: transparent;
    padding: 5px 10px;

    @media (max-width: 768px) {
      width: 100%;
      padding: 8px 10px;
      border: 1px solid #e0e0e0;
      border-radius: 8px;
    }

    &::placeholder {
      color: #919191ff;
    }
  }

  select {
    flex: 1;
    border: none;
    outline: none;
    background: transparent;
    font-size: 14px;
    cursor: pointer;
    color: #535353;
    padding: 5px 10px;
    max-width: 150px;

    @media (max-width: 768px) {
      width: 100%;
      max-width: 100%;
      padding: 8px 10px;
      border: 1px solid #e0e0e0;
      border-radius: 8px;
    }

    &::placeholder {
      color: #919191ff;
    }

    option {
      color: #000;
    }
  }
`

export const Divider = styled.div`
  width: 1px;
  height: 28px;
  background: #e3e3e3;

  @media (max-width: 768px) {
    display: none;
  }
`

export const VerticalDivider = styled.div`
  width: 100%;
  height: 2px;
  background: #e3e3e3;
`

export const SearchButton = styled.button`
  background: #2a6bf2;
  color: white;
  border: none;
  padding: 10px 22px;
  border-radius: 24px;
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  transition: 0.2s ease;

  @media (max-width: 768px) {
    width: 100%;
    justify-content: center;
    padding: 12px;
  }

  &:hover {
    background: #1f56c9;
  }
`

export const AbsoluteModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgb(124 124 124 / 50%);
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  min-height: 100vh;
  overflow: auto;
  opacity: 0;
  display: none;
  transition: max-height 0.4s ease, opacity 0.3s ease;

  ${({ open }) =>
    open &&
    css`
      max-height: 200px;
      opacity: 1;
      margin-top: 0px;
      display: block;
      transition: max-height 0.4s ease, opacity 0.3s ease;
    `}
`

export const ExpandArea = styled.div`
  height: 100%;
  overflow: hidden;
  background: white;
  height: fit-content;
  padding: 20px;
  display: flex;
  justify-content: space-around;
`
